import apiClient from '@/services/api/apiClient';

export default {
  getFilters: () => apiClient.get('/filters/'),
};
